import * as React               from 'react';

import cc                       from 'classcat';

import { Container,
         RadioItem,
         Control,
         Label,
         RadioGroupVariants,
         radiogroup_variants, 
         LabelContainer,
         IconContainer        } from 'src/components/common/radio-group/ui';



export type RadioGroupItem = {
  id: string;
  label: string;
  iconKey?: string;
}

export type RadioGroupIcons = {
  [key: string]:  React.ReactNode;
}

type Props = {
  variant: RadioGroupVariants;
  layout?: 'vertical' | 'horizontal-left' | 'horizontal-center';
  items: RadioGroupItem[];
  value: RadioGroupItem;
  icons?: RadioGroupIcons
  isDisabled?: boolean;
  onChange: (value: RadioGroupItem) => void;
}
export const RadioGroup: React.FC<Props> = ({
  variant,
  layout = 'vertical',
  items,
  value,
  icons,
  isDisabled = false,
  onChange,
}) => {
  const lookAndFeel = radiogroup_variants.get(variant)!;

  const onRadioClickHandler = (item: RadioGroupItem) => {
    if (!isDisabled)
    {
      onChange(item);
    }
  }

  const renderItem =(item: RadioGroupItem) => {
    if (variant === 'light') {
      return (
        <RadioItem
        key = { item.id }
        lookAndFeel = { lookAndFeel }
        className = { cc({ disabled: isDisabled }) }
        onClick = { onRadioClickHandler.bind(null, item) }
        >
          <Control
            lookAndFeel = { lookAndFeel }
            className = { cc({ selected: item.id === value.id }) }
            />
          <Label lookAndFeel = { lookAndFeel }>{ item.label }</Label>
        </RadioItem>
      )
    }

    if (variant === 'lightwithicon') {
      return (
        <RadioItem
          key = { item.id }
          lookAndFeel = { lookAndFeel }
          className = { cc({ disabled: isDisabled }) }
          onClick = { onRadioClickHandler.bind(null, item) }
          >
          <Control
            lookAndFeel = { lookAndFeel }
            className = { cc({ selected: item.id === value.id }) }
            />
          <LabelContainer>
            <IconContainer>
              { item.iconKey && icons ? icons[item.iconKey] : null}
            </IconContainer>
            <Label lookAndFeel = { lookAndFeel }>{ item.label }</Label>
          </LabelContainer>
        </RadioItem>
      )
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel } layout = { layout }>
      { items.map((item) => renderItem(item)) }
    </Container>
  );
};
